import { Component, Input } from '@angular/core';
import { FilterService } from '@progress/kendo-angular-grid';
import { Helpers } from 'src/app/helpers';

@Component({
    selector: 'medpt-colon-seperated-filter',
    templateUrl: './colon-seperated-filter.component.html',
    styleUrl: './colon-seperated-filter.component.scss',
    standalone: false
})
export class ColonSeperatedFilterComponent {
  @Input() column: any;
  @Input() filter: any;
  @Input() filterService!: FilterService;
  @Input() data!: any[];
  selectedValues: { [key: string]: boolean } = {};
  uniqueValues: string[] = [];
 
  ngOnInit() {
    this.uniqueValues = this.getUniqueValues();
  }
 
  getUniqueValues(): string[] {
    const values = new Set<string>();
     this.data.forEach((item:any) => {
       const fieldValues = (item[this.column.field] || '').split(';');
       fieldValues.forEach((value:any) => {
        if(!Helpers.isNullOrUndefined(value) && value != ""){
          values.add(value.trim())
        }
       });
     });
     
    return Array.from(values);
  }
 
  onSelectionChange() {
    const filterValues = Object.keys(this.selectedValues)
      .filter((key) => this.selectedValues[key]);
 
    this.filterService.filter({
      logic: 'or',
      filters: filterValues.map((value) => ({
        field: this.column.field,
        operator: 'contains',
        value
      }))
    });
  }
}
